module.exports = __webpack_public_path__ + "img/en-box.fca80eac.png";